namespace $.$$ {
	$mol_style_define($shm_hitalama_map_widget_view_dom,{
		display:'block',
		height:'100%',
		userSelect:'text',
	})
}
